import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';

export interface SignatureFieldModel extends BaseFieldModel {
  defaultValue: undefined;
  type: FieldType.Signature;
}

export class SignatureField extends BaseField implements SignatureFieldModel {
  public defaultValue: undefined;
  public type: FieldType.Signature = FieldType.Signature;

  constructor(cultures: string[]) {
    super(FieldType.Signature, cultures);
  }
}
